import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import "../assets/css/EditTenant.css";
import "../assets/css/DigixLeads.css";
import "../assets/css/AddSocialaccount.css";
import axiosInstance from "../components/api/axiosInstance";
import SocialAccountFields, {
  emptySocialAccountForm,
  socialAccountFormError,
  socialAccountPayload,
  socialAccountToForm,
} from "../components/SocialAccountFields";
import { getAuthItem } from "../utils/authStorage";
import { formValueWithMobileSanitize } from "../utils/phone";

function EditAccount({ accountId, onBack, onUpdate }) {
  const [formData, setFormData] = useState(() => emptySocialAccountForm());
  const [hasPassword, setHasPassword] = useState(false);

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchAccount = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get(`/social-account/${accountId}`);
        const account = response.data?.Account_Id ? response.data : response.data?.data || null;
        if (account) {
          setFormData(socialAccountToForm(account));
          setHasPassword(!!account.Has_Password);
        }
      } catch (err) {
        console.error("Error fetching account:", err);
        alert("Failed to load account details. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchAccount();
  }, [accountId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: formValueWithMobileSanitize(name, value)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formError = socialAccountFormError(formData, { hasSavedPassword: hasPassword });
    if (formError) {
      alert(formError);
      return;
    }

    // Get Updated_By from user
    let updatedBy = 1;
    try {
      const userStr = getAuthItem("user");
      if (userStr) {
        const user = JSON.parse(userStr);
        updatedBy = user.user_id || user.id || 1;
      }
    } catch (err) {
      console.error("Error reading user for Updated_By:", err);
    }

    const payload = { ...socialAccountPayload(formData), Updated_By: updatedBy };

    setSubmitting(true);
    try {
      const response = await axiosInstance.put(`/update-social-account/${accountId}`, payload);
      
      if (response.data) {
        alert("Account updated successfully");
        // Call parent callback to refresh accounts list
        if (onUpdate) {
          onUpdate();
        }
        // Navigate back to accounts page
        if (onBack) {
          onBack();
        }
      } else {
        throw new Error("Update failed - no response data");
      }
    } catch (err) {
      console.error("Error updating account:", err);
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Failed to update account.";
      alert(msg);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="edittenant-container">
        <div className="edittenant-loading">Loading account details...</div>
      </div>
    );
  }

  return (
    <div className="edittenant-container">
      <button className="back-link" onClick={onBack}>
        <FaArrowLeft /> Back 
      </button>
      <form className="edittenant-form" onSubmit={handleSubmit}>
        <SocialAccountFields
          form={formData}
          onChange={handleInputChange}
          hasSavedPassword={hasPassword}
          accountId={accountId}
        />

        <div className="edittenant-actions">
          <button type="submit" className="addaccount-create-btn" disabled={submitting}>
            {submitting ? "Updating..." : "Update Account"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditAccount;
